import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BaseDecarbFooterBar } from '../components/BaseDecarbFooterBar.tsx';
import { usePencilsDown } from '../hooks/usePencilsDown';
import { Tab } from '../types';

type Props = {
  currentTab: Tab;
  changeTab: (nextTab: Tab) => void;
  saveSubproject: () => Promise<void>;
};

export const HVACFooterBar: React.FC<Props> = ({
  currentTab,
  changeTab,
  saveSubproject,
}) => {
  const navigate = useNavigate();
  const pencilsDown = usePencilsDown();

  const onBackClick = async () => {
    try {
      if (currentTab === 'conventionalAlternative') {
        await saveSubproject();
        navigate('../');
      } else if (currentTab === 'reducedCarbonAlternative') {
        changeTab('conventionalAlternative');
      } else {
        await saveSubproject();
        changeTab('reducedCarbonAlternative');
      }
    } catch (error) {
      console.error('Failed to save:', error);
      alert('Failed to save changes. Please try again.');
    }
  };

  const onNextClick = async () => {
    try {
      if (currentTab === 'conventionalAlternative') {
        changeTab('reducedCarbonAlternative');
      } else if (currentTab === 'reducedCarbonAlternative') {
        changeTab('zeroCarbonAlternative');
      } else {
        await saveSubproject();
        navigate('../');
      }
    } catch (error) {
      console.error('Failed to save:', error);
      alert('Failed to save changes. Please try again.');
    }
  };

  return (
    <BaseDecarbFooterBar
      backText={
        currentTab === 'conventionalAlternative' ? 'RETURN TO HUB' : 'BACK'
      }
      onBackClick={onBackClick}
      nextText={
        currentTab === 'zeroCarbonAlternative' ? 'FINISH & RETURN' : 'NEXT'
      }
      onNextClick={onNextClick}
      onReturnToHubClick={async () => {
        try {
          await saveSubproject();
          navigate('../');
        } catch (error) {
          console.error('Failed to save:', error);
          alert('Failed to save changes. Please try again.');
        }
      }}
      returnText= {pencilsDown
          ? 'RETURN TO DECARBONIZATION HUB'
          : 'SAVE & RETURN TO DECARBONIZATION HUB'}
    />
  );
};
